import { NTHFlag } from '../../../constants/flag';
import { BpLineModel } from './bp-line.model';
import { SocieteLinkedModel } from '../societe-linked.model';
import { BcModel } from '../bc/bc.model';
import { CycleBpModel } from './cycle-bp.model';
import { LivraisonBcService } from 'src/app/shared/services/bc/livraison-bc.service';
import { LivraisonBcModel } from '../bc/livraison-bc.model';

export class BpModel extends SocieteLinkedModel {

    code: string = '*';
    // codeLib CA1
    codeCa1: string;
    libelleCa1: string;
    // Date du BP
    dBp: Date;
    // codeLib site
    codeSite: string;
    libelleSite: string;
    // codeLib site de livraison
    codeSiteLivr: string;
    libelleSiteLivr: string;
    // codeLib Fournisseur
    codeFourn: string;
    libelleFourn: string;
    // réference fournisseur
    refFourn: string;
    // codeLib condition de reglement
    codeCondRegl: string;
    libelleCondRegl: string;
    // codeLib Mode de reglement
    codeModeRegl: string;
    libelleModeRegl: string;
    // date de reglement
    dRegl: Date;
    // observations
    commentaires: string;
    // motif
    motif: string;
    // N° de facture
    numFacture: string;
    // montant ttc
    montantFacture: number;
    // Montant HT (obligatoire)
    ht: number;
    // Montant TVA (obligatoire)
    tva: number;
    // Montant TTC (obligatoire)
    ttc: number;
    // Flag | Boolean
    ruidEsker: string;
    fValide: NTHFlag;
    bFacture: boolean;
    bAnnule: boolean;
    bRetour: boolean;
    bBloque: boolean;
    // Statut
    status: string;
    // Dates
    dAnnule: Date;
    dCreation: Date;
    dFacture: Date;
    dModification: Date;

    // Liste de BP Lignes
    bpLines: BpLineModel[] = [];
    cycleBps: CycleBpModel[] = [];

    statusNum: number;
    position = 0; // non mappé

    bcs = '';

    trigrammeCreateur?: string;
    nomCompletCreateur?: string;

    urlFacture?: string;

    constructor(bc?: BcModel[], livs?: LivraisonBcModel[]) {
        super();
        if (bc) {
            if (bc.length > 0) {
                this.idSociete = bc[0].idSociete;
                this.dBp = new Date(Date.now());
                this.codeSite = bc[0].codeSite;
                this.libelleSite = bc[0].libelleSite;
                this.codeSiteLivr = bc[0].codeSiteLivraison;
                this.libelleSiteLivr = bc[0].libelleSiteLivraison;
                this.codeCa1 = bc[0].codeCa1;
                this.libelleCa1 = bc[0].libelleCa1;
                this.codeFourn = bc[0].codeFourn;
                this.libelleFourn = bc[0].libelleFourn;
                this.refFourn = bc[0].refFourn;
                this.codeCondRegl = bc[0].codeCondRegl;
                this.libelleCondRegl = bc[0].libelleCondRegl;
                this.codeModeRegl = bc[0].codeModeRegl;
                this.libelleModeRegl = bc[0].libelleModeRegl;
                this.numFacture = "UNDEFINED";
                this.dRegl = new Date();
                for (const objet of bc) {
                    this.bcs = this.bcs + objet.code + ',';
                }
                bc.forEach( // pour chaque bc
                    row => row.bcLines.forEach( // pour chaque ligne de chaque bc
                        bcL => { // on rajoute la ligne
                            if (bcL.fLivre === NTHFlag.Some || bcL.fLivre === NTHFlag.All) {
                                livs.forEach(liv => {
                                    if (liv.idBcLigne === bcL.id) {
                                        const bpligne = new BpLineModel(bcL, liv);
                                        this.bpLines.push(bpligne);
                                    }
                                }, this);
                            }
                        },
                        this // on précise quel objet est 'this', en l'occurrence, c'est 'this' (du niveau supérieur)
                    ),
                    this
                );
            }
        }
    }

}
